import { Injectable } from "@angular/core";
import { StoreService } from "./store.service";
import { Idea } from "src/generated/graphql";

export interface IdeaState {
  ideas: Idea[];
  selectedIdea?: Idea;
}

@Injectable({
  providedIn: "root",
})
export class IdeaStoreService extends StoreService<IdeaState> {
  constructor() {
    super({ ideas: [] }); // Estado inicial
  }

  // Método para adicionar usuários
  addIdeas(ideas: Idea[]): void {
    const currentState = this.getState();
    this.setState({ ...currentState, ideas });
  }

  // Método para definir o usuário selecionado
  selectedIdea(idea: Idea): void {
    const currentState = this.getState();
    this.setState({ ...currentState, selectedIdea: idea });
  }

  getSelectedUser(): Idea | undefined {
    return this.getState().selectedIdea;
  }
}
